import React, { useEffect, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { displayPreviewAtom } from '@src/state/shareAtoms';
import { loadDisplayPreview } from 'actions/share';
import { loadTranslation } from '@src/services/helpers/appHelpers';
import translation from './translation';
import Grid from './components/Grid';
import styles from './styles.module.scss';

const lang = loadTranslation(translation);

export default function Display() {
  const displayPreview = useAtomValue(displayPreviewAtom);

  useEffect(() => {
    loadDisplayPreview();
  }, []);

  const incorrectOrder = useMemo(() => {
    if (!displayPreview?.content?.length) {
      return {};
    }
    const content = displayPreview.content.filter((c) => !!c.date);
    const incorrect: { [key: string]: boolean } = {};
    let minDate: string | undefined = (content[0] || {}).date;
    content.forEach(({ _id, date }) => {
      if (minDate && date! > minDate) {
        incorrect[_id] = true;
      } else {
        minDate = date;
      }
    });
    return incorrect;
  }, [displayPreview]);

  return (
    <div className={styles.display}>
      <div className={styles.titlebar}>
        <div>
          {lang.title}
        </div>
      </div>
      {Object.keys(incorrectOrder).length ? (
        <div className="alert alert-warning text-center mb-3">
          {lang.dateOrderWarning}
        </div>
      ) : null}
      <Grid incorrectContentOrder={incorrectOrder} />
    </div>
  );
}
